"use client"

import { useState, useEffect } from "react"
import { Home, Rocket, ArrowLeft } from "lucide-react"
import { useLanguage } from "./LanguageContext"
import { loadAppConfiguration } from "./ContentLoader"
import { useSeo } from "./hooks/useSeo"
import Navigation, { Footer } from "./Navigation"
import "./css/AboutPage.css"
import "./css/NotFoundPage.css"

const NotFoundPage = () => {
  const { language } = useLanguage()
  const [appConfig, setAppConfig] = useState<any>(null)

  const nl = language.code === "nl"

  useSeo({
    path: typeof window !== "undefined" ? window.location.pathname : "/404",
    title: nl ? "Pagina niet gevonden | Techtok" : "Page not found | Techtok",
    description: nl
      ? "Deze pagina bestaat niet meer. Ga terug naar de homepage of speel de Techtok Missies."
      : "This page no longer exists. Head back to the homepage or play the Techtok Missions.",
    noindex: true,
  })

  const t = (path: string, defaultText = "") => {
    if (!appConfig) return defaultText
    const keys = path.split(".")
    let value: any = appConfig
    for (const key of keys) {
      if (!value || !value[key]) return defaultText
      value = value[key]
    }
    if (value && typeof value === "object" && value[language.code]) return value[language.code]
    return typeof value === "string" ? value : value?.en || defaultText
  }

  useEffect(() => {
    loadAppConfiguration(language.code, null, false)
      .then(setAppConfig)
      .catch((e) => console.warn("Kon configuratie niet laden voor 404-pagina:", e))
  }, [language.code])

  return (
    <div className="landing-selector-container notfound-page">
      <Navigation appConfig={appConfig} currentPage="none" onNavigate={() => {}} t={t} />

      <main className="main-content">
        <section className="notfound-hero">
          <div className="notfound-inner">
            <img src="/images/bella.png" alt="Bella" className="notfound-bella" />

            <p className="notfound-eyebrow">{nl ? "Fout 404" : "Error 404"}</p>

            <h1 className="notfound-title">
              {nl ? "Bella kan deze pagina niet vinden" : "Bella can't find this page"}
            </h1>

            <p className="notfound-text">
              {nl
                ? "De link klopt niet meer, of heeft nooit bestaan. Geen zorgen, hier kun je wel verder:"
                : "The link is broken, or it never existed. No worries, here's where to go instead:"}
            </p>

            <div className="notfound-actions">
              <a href="/" className="notfound-btn notfound-btn-primary">
                <Home size={18} />
                {nl ? "Naar de homepagina" : "Go to the homepage"}
              </a>
              <a href="/games/missies/" className="notfound-btn notfound-btn-secondary">
                <Rocket size={18} />
                {nl ? "Speel de Missies" : "Play the Missions"}
              </a>
            </div>

            <button
              type="button"
              className="notfound-back"
              onClick={() => {
                if (window.history.length > 1) window.history.back()
                else window.location.href = "/"
              }}
            >
              <ArrowLeft size={15} />
              {nl ? "Ga terug naar de vorige pagina" : "Go back to the previous page"}
            </button>
          </div>
        </section>
      </main>

      <Footer appConfig={appConfig} t={t} />
    </div>
  )
}

export default NotFoundPage
